import { defineComponent as _defineComponent } from 'vue';
import { computed, onMounted, ref } from "vue";
import { markup } from "@/components/ObjectStore/configurationMarkdown";
import { useFormattedToolHelp } from "@/composables/formattedToolHelp";
import { getAppRoot } from "@/onload/loadConfig";
import HelpPopover from "@/components/Help/HelpPopover.vue";
export default /*#__PURE__*/ _defineComponent({
    __name: 'ToolHelpMarkdown',
    props: {
        content: null
    },
    setup(__props) {
        const props = __props;
        const markdownHtml = computed(() => markup(props.content ?? "", false));
        // correct links and header information... this should work the same between rst and
        // markdown entirely I think.
        const { formattedContent } = useFormattedToolHelp(markdownHtml);
        const helpHtml = ref();
        const internalHelpReferences = ref([]);
        function setupPopovers() {
            internalHelpReferences.value.length = 0;
            if (helpHtml.value) {
                const links = helpHtml.value.getElementsByTagName("a");
                Array.from(links).forEach((link) => {
                    if (link.href.startsWith("gxhelp://")) {
                        const uri = link.href.substr("gxhelp://".length);
                        internalHelpReferences.value.push({ element: link, term: uri });
                        link.href = `${getAppRoot()}help/terms/${uri}`;
                        link.style.color = "inherit";
                        link.style.textDecorationLine = "underline";
                        link.style.textDecorationStyle = "dashed";
                    }
                });
                const imgs = helpHtml.value.getElementsByTagName("img");
                Array.from(imgs).forEach((img) => {
                    if (img.src.startsWith("gxstatic://")) {
                        const rest = img.src.substr("gxstatic://".length);
                        img.src = `${getAppRoot()}static/${rest}`;
                    }
                });
            }
        }
        onMounted(setupPopovers);
        return { __sfc: true, props, markdownHtml, formattedContent, helpHtml, internalHelpReferences, setupPopovers, HelpPopover };
    }
});
